import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl shadow-lg elevation-2">
          <Icon name="Palette" size={32} color="white" />
        </div>
      </div>
      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">Welcome Back</h1>
        <p className="text-lg text-muted-foreground">Admin Panel</p>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Sign in to manage artist content, oversee platform operations, and access your personalized dashboard
        </p>
      </div>
      {/* Current Date */}
      <div className="mt-4 text-xs text-muted-foreground">
        {new Date()?.toLocaleDateString('en-US', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        })}
      </div>
    </div>
  );
};

export default WelcomeHeader;